import axios from "../../plugins/axios";

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    balancosPorAno(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('balanco-energetico/listar-balancos-ano' + payload,)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    todosOsBalancosPaginados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('balanco-energetico' + payload,)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    balancosPorReferencia(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`balanco-energetico/` + payload.referencia + payload.query)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    balancosPorReferenciaeConsorcio(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`balanco-energetico/` + payload.referencia + "/" + payload.consorcio + '?' + payload.query)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    balancoPorReferenciaUC(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`balanco-energetico/` + payload.id + "/cliente")
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listarHistoricoAnteriores(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`balanco-energetico/historico/` + payload.id + '/balancos')
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    balancosPorReferenciaLista(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put(`balanco-energetico/` + payload.referencia + "/" + 'lista', {
                query: payload.query,
                referencia: payload.referencia
            })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    historicoBalanco(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('balanco-energetico/historico/' + payload + "/log?loading=false&loading=false")
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    boletarEmMassa(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-financeiro/boletar-em-massa', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selecionarBalanco(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/selecionar-balanco', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selecionarTodos(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/selecionar-todos-balancos', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    retornaQuantidadeSelecionada(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('balanco-energetico/retorna-quantidade-selecionada?loading=false&loading=false&referencia=' + payload.referencia + '&estado=' + payload.estado)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    inativarEmMassa(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('balanco-energetico/inativar-em-massa' + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    verificarControleBalanco(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('controle-balanco/' + payload.referencia + '/balanco')
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    reprocessar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('fix/reprocessar', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    reprocessarEstado(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('fix/reprocessar-por-estado', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getEstornosCount(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('balanco-energetico/balanco-estornados')
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    reprocessarSelecionados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/reprocessar', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    atualizarEmMassa(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/atualizacao-em-massa', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    excluirBalanco(context, payload) {
        return new Promise((resolve, reject) => {
            let requestData = {};
            
            // If specific IDs are provided (individual deletion)
            if (payload.ids) {
                requestData = { ids: payload.ids };
            }
            // If referencia and estado are provided (bulk deletion)
            else if (payload.referencia && payload.estado) {
                requestData = { 
                    referencia: payload.referencia, 
                    estado: payload.estado 
                };
            }
            
            axios.delete('balanco-energetico/excluir-selecionados', { data: requestData })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    mudarEstado(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/mudar-estado', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    AcaoReprocessar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/reprocessar-acao', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    calcularPorGD(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/calcular-gd/job', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    trocainfo(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('balanco-energetico/troca-info', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/balanco.js